import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import Switch, { Case } from "react-switch-case";

import OrderCardProdView from "./OrderCardProdView";
import OrderCardButtonCase from "pages/layers/orderDetail/OrderCardButtonViewCase";
import BaeminOrderCardButtonViewCase from "pages/layers/orderDetail/BaeminOrderCardButtonViewCase";
import { fn_orderDetail, fn_orderEndDetail } from "function/FnBodyDetail";
import { comma, partnerIcon, getOrderTypeStyle, baeminMobileOrderFg, selfDlvMobileOrderFg } from "utils/Utils";
import { MobileOrderFg, StepCd } from "types";

const OrderCardTypeItemView = ({ rootStore, order }) => {
  const searchStore = rootStore.searchStore;

  useEffect(() => {
    rootStore.orderStore.setOrderListStyle({ mobileOrderNo: order.mobileOrderNo, onStyle: false });
  }, [rootStore, order]);

  if (order.partnerType === "BAEMIN") {
    if (order.morderTypeCd === "P") {
      order.partnerType = "BAEMIN_PICKUP";
    } else if (order.morderTypeCd === "O") {
      order.partnerType = "BAEMIN_SHOP";
    }
  }

  let img_icon = partnerIcon(order.partnerType);

  let cidTelNo = "";
  if (order.mobileOrderFg === MobileOrderFg.CID && !(order.cstTelNo === null || order.cstTelNo === "")) {
    cidTelNo = order.cstTelNo.split("-")[2];
  }

  let dlvAddr = "";
  if (order.dlvAddr) {
    let dlvAddrArr = order.dlvAddr.split(" ");
    if (dlvAddrArr && dlvAddrArr.length > 1) {
      dlvAddr = dlvAddrArr[dlvAddrArr.length - 2] + " " + dlvAddrArr[dlvAddrArr.length - 1];

      if (dlvAddr && dlvAddr.length > 5) dlvAddr = dlvAddr.substring(0, 6) + "...";
    }
  }

  let remain_cnt = 0;
  let prod_containers = [];
  if (order.viewProds !== null) {
    remain_cnt = order.viewProds.length;
  }
  if (Array.isArray(order.viewProds) && order.viewProds.length > 0) {
    let prod_views = order.viewProds.filter((prods, idx) => idx < 4);
    prod_views.forEach((prod, index) => {
      remain_cnt = remain_cnt - 1;
      prod_containers.push(
        <OrderCardProdView
          key={index + prod.prodCode}
          rootStore={rootStore}
          index={index}
          prod={prod}
        ></OrderCardProdView>
      );
    });
  }

  let checkOnStyle;
  rootStore.orderStore.getOrderListStyle.map(data => {
    if (data.mobileOrderNo === order.mobileOrderNo) {
      checkOnStyle = data.onStyle;
    }
  });

  let orderTypeStyle = getOrderTypeStyle(order.orderType);

  let checkCallBack =
    order.mobileOrderFg === MobileOrderFg.BAEMIN_ONE || order.mobileOrderFg === MobileOrderFg.BAEMIN_STORE
      ? true
      : false;
  let infoText = "";
  let telYn = false;

  if (
    order.partnerEtcInfo !== null &&
    order.partnerEtcInfo !== "" &&
    order.partnerEtcInfo !== undefined &&
    order.partnerEtcInfo === "no_show"
  ) {
    infoText = "고객미방문";
  } else if (order.reservedTime !== null && order.reservedTime !== "" && order.reservedTime !== undefined) {
    infoText = order.reservedTime + " 예약";
  } else if (order.bellNo || order.deliverNo) {
    infoText = "진동벨 " + (order.bellNo || order.deliverNo);
  } else if (order.registNumber !== null && order.registNumber !== "" && order.registNumber !== undefined) {
    infoText = order.registNumber;
  } else if (order.waitingNo !== null && order.waitingNo !== "" && order.waitingNo !== undefined) {
    infoText = "대기" + order.waitingNo;
    if (order.tableNo !== null && order.tableNo !== "" && order.tableNo !== undefined) {
      infoText = infoText + "(T-" + order.tableNo + ")";
    }
  } else if (order.tableNo !== null && order.tableNo !== "" && order.tableNo !== undefined) {
    infoText = "(T-" + order.tableNo + ")";
  } else if (order.tableNm !== null && order.tableNm !== "" && order.tableNm !== undefined) {
    infoText = order.tableNm;
  } else if (order.cstNm !== null && order.cstNm !== "" && order.cstNm !== undefined) {
    infoText = order.cstNm;
  } else if (order.cstTelNo !== null && order.cstTelNo !== "" && order.cstTelNo !== undefined) {
    infoText = order.cstTelNo;
    telYn = true;
  }

  let timeClass = "";
  let timeCnt = "";

  if (order.stepCd !== StepCd.ORDER_COMPLETED && order.stepCd !== StepCd.ORDER_CANCELLED) {
    if (
      200 > parseInt(order.stepCd) ||
      parseInt(order.stepCd) > 600 ||
      Number(order.time) < -180 ||
      order.time === null
    ) {
      timeClass = "time";
      timeCnt = "";
    } else {
      if (Number(rootStore.settingStore.getCookingDfTime) <= Number(order.time)) {
        timeClass = "time time_noraml";
        timeCnt = order.time + "분 남음";
      } else if (0 <= Number(order.time) < Number(rootStore.settingStore.getCookingDfTime)) {
        if (0 <= Number(order.time * -1) && Number(rootStore.settingStore.getCookingDfTime) * -1 < Number(order.time)) {
          timeClass = "time time_over";
          timeCnt = Number(order.time * -1) + "분 경과";
        } else if (Number(order.time) <= Number(rootStore.settingStore.getCookingDfTime) * -1) {
          timeClass = "time time_max";
          timeCnt = Number(order.time * -1) + "분 경과";
        } else {
          timeClass = "time time_alert";
          timeCnt = order.time + "분 남음";
        }
      }
    }
  }

  return (
    <li className={checkOnStyle ? "on" : ""}>
      <div className="card_item">
        <button
          type="button"
          onClick={() => {
            order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED
              ? fn_orderEndDetail(rootStore, order.mobileOrderNo, "endOrderView")
              : fn_orderDetail(rootStore, order.mobileOrderNo, "order");
          }}
        >
          <span className="top">
            <strong className="num">
              {baeminMobileOrderFg(order.mobileOrderFg) ? order.mobileOrderNo.slice(-4) : order.mobileOrderNoView}
              {order.new_yn === "Y" ? <span className="new">신규주문</span> : ""}
              <span className="txt">
                {order.orderType === "DELIVERY" ? (
                  <Switch condition={order.stepCd}>
                    <Case value="200">배차전</Case>
                    <Case value="500">
                      <Switch
                        condition={
                          order.dlvStatusFg
                            ? order.mobileOrderFg === MobileOrderFg.BAEMIN_STORE
                              ? "05"
                              : order.dlvStatusFg
                            : ""
                        }
                      >
                        <Case value="00">배차중</Case>
                        <Case value="02">픽업중</Case>
                        <Case value="03">배달중</Case>
                        <Case value="04">배달완료</Case>
                        <Case value="">배차전</Case>
                        <Case value="99">배차전</Case>
                        <Case value="05">진행중</Case>
                      </Switch>
                    </Case>
                  </Switch>
                ) : checkCallBack ? (
                  <Switch condition={order.stepCd}>
                    <Case value="200">진행중</Case>
                    <Case value="300">조리중</Case>
                  </Switch>
                ) : (
                  <Switch condition={order.stepCd}>
                    <Case value="200">조리중</Case>
                    <Case value="300">호출</Case>
                  </Switch>
                )}
              </span>
            </strong>
            {selfDlvMobileOrderFg(order.mobileOrderFg) ? (
              (order.mobileOrderFg === MobileOrderFg.BAEMIN_ONE ||
                order.mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS) &&
              order.elapseTime === "0" ? (
                <span className="cooking">조리대기</span>
              ) : (
                <span
                  className={
                    200 > parseInt(order.stepCd) ||
                    parseInt(order.stepCd) > 600 ||
                    Number(order.time) < -180 ||
                    order.time === null
                      ? "time"
                      : Number(order.time) >= 0
                      ? "pickup"
                      : "pickup over"
                  }
                >
                  {parseInt(order.stepCd) < 700
                    ? 200 > parseInt(order.stepCd) ||
                      parseInt(order.stepCd) > 600 ||
                      Number(order.time) < -180 ||
                      order.time === null
                      ? ""
                      : Number(order.time) < 0
                      ? order.time * -1 + "분 경과"
                      : order.time + "분 픽업"
                    : ""}
                </span>
              )
            ) : (
              <span className={timeClass}>{timeCnt}</span>
            )}
          </span>
          <span className="info">
            <span className="receipt_time">{order.orderTimeView}</span>
            <span className="bar"></span>
            {order.orderType === "DELIVERY" ? (
              baeminMobileOrderFg(order.mobileOrderFg) ? (
                <span className="name">
                  {order.reservedTime !== "" && order.reservedTime !== null
                    ? order.reservedTime + " 예약"
                    : order.dlvAddrDong !== ""
                    ? order.dlvAddrDong
                    : order.mobileOrderNoView.slice(-4)}
                </span>
              ) : cidTelNo === "" ? (
                <span className="name">{dlvAddr}</span>
              ) : (
                <span>
                  <span className="phone"></span>
                  <span className="phone_num"> {cidTelNo} </span>
                </span>
              )
            ) : telYn ? (
              <span>
                <span className="phone"></span>
                <span className="phone_num"> {cidTelNo} </span>
              </span>
            ) : (
              <p className="ml-2 text-[15px] text-black overflow-hidden text-ellipsis whitespace-nowrap max-w-[110px] float-left">
                {infoText}
              </p>
            )}
            <strong className="num">{order.mainMenuCount === null ? "ㅤㅤ" : order.mainMenuCount}개</strong>
          </span>
          <span className="menu">
            {prod_containers}
            {order.isPartialCanceled ? <span className="o r">부분 취소</span> : null}
            {order.over ? <span className="o over">과적</span> : null}
            {remain_cnt > 0 ? <span className="o">더보기</span> : null}
          </span>
          <div className="box">
            <span className="total">
              <span className="thumb">
                <img src={img_icon} width="24" height="24" alt={"logo"} />
                <span className="frame"></span>
              </span>
              <span className={orderTypeStyle}>
                {order.selfDeliveryType !== null && order.selfDeliveryType !== ""
                  ? order.selfDeliveryType
                  : order.orderTypeView}
              </span>
              <strong className="pay">
                {comma(order.orderAmount)}원
                <span>
                  {order.payTypeView === "선불" || order.payTypeView === "후불"
                    ? "(" + order.payTypeView + ")"
                    : order.payTypeView}
                </span>
              </strong>
            </span>
          </div>
        </button>
        {baeminMobileOrderFg(order.mobileOrderFg) ? (
          <BaeminOrderCardButtonViewCase rootStore={rootStore} order={order} searchStore={searchStore} />
        ) : (
          <OrderCardButtonCase rootStore={rootStore} order={order} searchStore={searchStore} />
        )}
      </div>
    </li>
  );
};

export default inject("rootStore")(observer(OrderCardTypeItemView));
